// extracted by mini-css-extract-plugin
export var blink = "_8l-2";
export var cursor = "_8l-1";
export var reactMarkdown = "_8l-3";
export var streamingText = "_8l-0";